import script from "./Share.vue?vue&type=script&setup=true&lang=js"
export * from "./Share.vue?vue&type=script&setup=true&lang=js"

import "./Share.vue?vue&type=style&index=0&id=083d7858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083d7858"]])

export default __exports__